interface LoadingStateProps {
  variant?: 'fullscreen' | 'inline' | 'overlay' | 'page'
}

const LoadingState = ({ 
  variant = 'fullscreen'
}: LoadingStateProps) => {
  const spinner = (
    <div className="w-8 h-8 border-4 border-gray-300 border-t-gray-500 rounded-full animate-spin" />
  )
  
  if (variant === 'inline') {
    return (
      <div className="flex items-center justify-center py-12">
        {spinner}
      </div>
    )
  }
  
  if (variant === 'overlay') {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center z-50">
        {spinner}
      </div>
    )
  }
  
  if (variant === 'page') {
    // Page variant - clean centered spinner on full screen
    return (
      <div className="h-full min-h-0 bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        {spinner}
      </div>
    )
  }
  
  // fullscreen - default for page loads
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
      {spinner}
    </div>
  )
}

export default LoadingState


